import { storybookReady } from '../../../core/js/utils'
import { loggedInPromise } from '../login/login'

let storybook

(async function () {
  storybook = await storybookReady()

  document.querySelectorAll('.Favourites').forEach(item => {
    let favourites = new Favourites(item)
  })
})()

class Favourites {
  constructor (element) {
    storybook && console.log('Favourites')

    this.element = element

    this.element.querySelectorAll('.wishlistButtonContainer .Button').forEach(item => {
      item.addEventListener('click', (event) => {
        storybook && console.log('click')
        event.preventDefault()
        this.login()
      })
    })
  }
  login () {
    loggedInPromise().then(loggedIn => {
      storybook && console.log('loggedIn', loggedIn)
      if (loggedIn) {
        location.href = location.pathname + '?ck=' + Date.now() + '#' + this.element.id
      }
    })
  }
}
